import React, { useState,useEffect } from 'react';
import './css/bootstrap.min.css';
import './css/slick.css';
import './css/style.css';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";
import Home from './components/Home/Home';
import Treatment from './components/Treatment/Treatment';
import Team from './components/Team/Team';
import Contact from './components/Contact/Contact';
import About from './components/About/About';
import Faq from './components/FAQ/Faq';
function App(){
  return (
    <div>
      <Router>
      {/* {<Router  basename="reactjs-medicare/">} */}
        <Route exact path="/" component={Home}></Route>
        <Route  path="/treatment" component={Treatment}></Route>
        <Route  path="/team"  component={Team}></Route>
        <Route  path="/contact" component={Contact}></Route>
        <Route  path="/about" component={About}></Route>
        <Route  path="/faq" component={Faq}></Route>
      </Router>
    </div>
  );
}
export default App;
